import { useEffect, useRef, useState } from 'react';

export const useLoadingAnnouncement = (
  isLoading: boolean,
  loadingMessage = 'Loading'
): string => {
  const [message, setMessage] = useState('');
  const wasLoading = useRef(false);
  const isInitialMount = useRef(true);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      wasLoading.current = isLoading;
      return;
    }

    if (isLoading) {
      wasLoading.current = true;
      setMessage('');
      const timeoutId = window.setTimeout(() => {
        setMessage(loadingMessage);
      }, 50);
      return () => window.clearTimeout(timeoutId);
    }

    if (wasLoading.current) {
      wasLoading.current = false;
      setMessage('');
    }
  }, [isLoading, loadingMessage]);

  return message;
};
